module.exports = __webpack_public_path__ + "img/news10.bea2ee20.jpg";